import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabase';
import styles from '../styles/Signin.module.css';

function SignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className={styles.container}>
      {/* Floating orbs */}
      <div className={`${styles.orb} ${styles.orbGold}`} />
      <div className={`${styles.orb} ${styles.orbGreen}`} />

      {/* Card */}
      <div className={styles.card}>
        {/* Shimmer stripe */}
        <div className={styles.cardStripe} />

        <div className={styles.cardBody}>
          {/* Logo */}
          <img
            onLoad={(e) => e.currentTarget.classList.add('loaded')}
            src="/GroupSoup.png"
            alt="GroupSoup"
            className={styles.logoImg}
          />

          {/* Heading */}
          <h1 className={styles.title}>Welcome back</h1>
          <p className={styles.subtitle}>Sign in to your GroupSoup account</p>

          {/* Form */}
          <form className={styles.form} onSubmit={handleSignIn}>
            <div className={styles.inputGroup}>
              <label className={styles.label}>Email</label>
              <input
                className={styles.input}
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.label}>Password</label>
              <input
                className={styles.input}
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {error && <p className={styles.error}>{error}</p>}

            <button className={styles.submitBtn} type="submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign In'}
            </button>
          </form>

          {/* Footer links */}
          <div className={styles.footer}>
            <p className={styles.footerText}>
              Don't have an account?{' '}
              <button className={styles.link} onClick={() => navigate('/sign-up')}>
                Sign Up
              </button>
            </p>
            <p className={styles.footerText}>
              Forgot your password?{' '}
              <button className={styles.link} onClick={() => navigate('/password-reset')}>
                Reset it
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
